<template>
  <div class="download-box">
    <div class="download-container">
      <div class="title-container">
        <div style="text-align: center" class="reveal-bottom">
          <span class="title-icon"></span>
          <div class="title-name">{{ $t("m100.download_sase") }}</div>
          <div :class="lang === 'en_US' ? 'title-desc-en' : 'title-desc'">
            {{ $t("m100.download_sase_tip") }}
          </div>
          <div class="title-btn">
            <div class="btn-container" @click="getOS">
              {{ $t("m100.c5") }}
            </div>
          </div>
          <div :class="lang === 'en_US' ? 'clinet-bg-en' : 'clinet-bg'"></div>
        </div>
      </div>
    </div>

    <div class="download-content reveal-bottom">
      <div style="display: flex">
        <!-- IOS -->
        <div class="content-box">
          <div style="margin-bottom: 16px">
            <span class="content-icon ios-icon"></span
            ><span class="content-name">IOS</span>
          </div>
          <!-- <div class="content-info">
            {{ $t("m100.download_development") }}...
          </div> -->
          <div>
            <DownloadQrLink
              href="https://apps.apple.com/us/app/obc-sase/id6758335442"
            >
              <a
                class="content-download-a"
                href="https://apps.apple.com/us/app/obc-sase/id6758335442"
                target="_blank"
              >
                <span class="content-tips">{{ $t("m100.download") }}</span>
                <span class="content-arrow"></span>
              </a>
            </DownloadQrLink>
          </div>
        </div>
        <!-- Android -->
        <div class="content-box">
          <div style="margin-bottom: 16px">
            <span class="content-icon android-icon"></span
            ><span class="content-name">Android</span>
          </div>
          <div>
            <DownloadQrLink :href="android && android.url">
              <a
                class="content-download-a"
                :href="android && android.url"
                :dwonload="android && android.name"
                target="_blank"
              >
                <span class="content-tips">{{ $t("m100.download") }}</span>
                <span class="content-arrow"></span>
              </a>
            </DownloadQrLink>
          </div>
        </div>
        <!-- Mac -->
        <div class="content-box">
          <div style="margin-bottom: 16px">
            <span class="content-icon mac-icon"></span
            ><span class="content-name">Mac</span>
          </div>
          <div class="content-download" style="margin-bottom: 16px">
            <DownloadQrLink :href="macIntel && macIntel.url">
              <a
                class="content-download-a"
                :href="macIntel && macIntel.url"
                :dwonload="macIntel && macIntel.name"
                target="_blank"
              >
                <span class="content-tips"
                  >{{ $t("m100.download")
                  }}{{ $t("m100.download_intel_x86") }}</span
                >
                <span class="content-arrow"></span>
              </a>
            </DownloadQrLink>
          </div>
          <div class="content-download">
            <DownloadQrLink :href="macApple && macApple.url">
              <a
                class="content-download-a"
                :href="macApple && macApple.url"
                :dwonload="macApple && macApple.name"
                target="_blank"
              >
                <span class="content-tips"
                  >{{ $t("m100.download") }}{{ $t("m100.download_m") }}</span
                >
                <span class="content-arrow"></span>
              </a>
            </DownloadQrLink>
          </div>
        </div>
      </div>

      <div style="display: flex">
        <!-- Windows -->
        <div class="content-box" style="border-bottom: none">
          <div style="margin-bottom: 16px">
            <span class="content-icon window-icon"></span
            ><span class="content-name">Windows</span>
          </div>
          <div class="content-download" style="margin-bottom: 16px">
            <DownloadQrLink :href="windows && windows.url">
              <a
                class="content-download-a"
                :href="windows && windows.url"
                :dwonload="windows && windows.name"
                target="_blank"
              >
                <span class="content-tips">{{ $t("m100.download") }}</span>
                <span class="content-arrow"></span>
              </a>
            </DownloadQrLink>
          </div>
        </div>
        <!-- HarmonyOS -->
        <div class="content-box" style="border-bottom: none">
          <div style="margin-bottom: 16px">
            <span class="content-icon harmonyOS-icon"></span
            ><span class="content-name">HarmonyOS NEXT</span>
          </div>
          <div class="content-download" style="margin-bottom: 16px">
            <div class="harmonyOS-tip">{{ $t("m100.harmonyOS_tip") }}</div>
            <DownloadQrLink
              href="https://appgallery.huawei.com/app/detail?id=com.oceanbluecloud.sase"
            >
              <a
                class="content-download-a"
                href="https://appgallery.huawei.com/app/detail?id=com.oceanbluecloud.sase"
                target="_blank"
              >
                <span class="content-tips">{{ $t("m100.download") }}</span>
                <span class="content-arrow"></span>
              </a>
            </DownloadQrLink>
          </div>
        </div>
        <!-- 麒麟/统信 -->
        <div class="content-box" style="border: none"></div>
      </div>
    </div>

    <!-- 自定义弹窗 -->
    <div
      class="modal-container reveal-bottom"
      :class="dialogVisible ? 'modal-show' : 'modal-hidden'"
    >
      <div class="modal-box">
        <div class="modal-header">
          <span class="modal-close" @click="showModal"></span>
          <div class="modal-title">{{ $t("m100.download_type") }}</div>
          <div>
            <div class="modal-btn" style="margin-right: 24px">
              <a
                class="content-download"
                :href="macIntel && macIntel.url"
                :dwonload="macIntel && macIntel.name"
                target="_blank"
              >
                <div class="title-h1">{{ $t("m100.download_intel") }}</div>
                <div class="title-h3">{{ $t("m100.download_intel2") }}</div>
              </a>
            </div>
            <div class="modal-btn">
              <a
                class="content-download"
                :href="macApple && macApple.url"
                :dwonload="macApple && macApple.name"
                target="_blank"
              >
                <div class="title-h1">{{ $t("m100.download_apple") }}</div>
                <div class="title-h3">{{ $t("m100.download_apple2") }}</div>
              </a>
            </div>
          </div>
        </div>

        <div class="modal-content">
          <div class="modal-tips">{{ $t("m100.download_type_tip") }}</div>
          <div class="modal-tips-img">
            <span class="modal-tips-img-1" style="margin-right: 20px"></span>
            <span class="modal-tips-img-2"></span>
          </div>

          <div class="modal-tips-img">
            <span class="modal-tips-title-1" style="margin-right: 20px">
              {{ $t("m100.download_type_tip2") }}
            </span>
            <span class="modal-tips-title-2">{{
              $t("m100.download_type_tip3")
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import initAnimation from "../animation";
import { Dialog } from "element-ui";
import Vue from "vue";
import DownloadQrLink from "@/components/DownloadQrLink.vue";
Vue.component(Dialog.name, Dialog);
import axios from "@/http";
export default {
  components: {
    DownloadQrLink,
  },
  data() {
    return {
      android: null,
      macApple: null,
      macIntel: null,
      windows: null,
      lang: localStorage.getItem("lang"),
      dialogVisible: false,
    };
  },
  mounted() {
    setTimeout(initAnimation, 0);
    this.$bus.$on("lang", (lang) => {
      this.lang = lang;
    });
  },
  created() {
    this.getData();
  },
  methods: {
    back: function () {
      this.$router.back();
    },
    showModal: function () {
      this.dialogVisible = !this.dialogVisible;
    },
    getData: async function () {
      const res = await axios.get("/api3/version/M100");
      console.log(res);
      if (res.code === 0) {
        this.android = res.data.ANDROID;
        this.macApple = res.data.MAC_APPLE;
        this.macIntel = res.data.MAC_INTEL;
        this.windows = res.data.WINDOWS;
      }
    },
    getDownload() {
      console.log(this.getOS());
      if (this.getOS()) {
        console.log(this.getOS());
        const fileUrl = this.getOS().url; // 你实际的文件地址
        const fileName = this.getOS().name; // 下载后的文件名
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = fileName;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    getOS() {
      const ua = navigator.userAgent.toLowerCase();
      const platform = navigator;
      console.log(ua);
      console.log(platform);
      if (ua.includes("windows")) {
        this.getDownload(this.windows);
      }

      if (ua.includes("mac os x")) {
        this.showModal();
      }
    },
  },
};
</script>
<style scoped>
.download-container {
  width: 100%;
  height: 844px;
  background-image: url("../../assets/images/download/download-bg.png");
  background-size: cover;
  padding-top: 100px;
  box-sizing: border-box;
}
.title-container {
  width: 1200px;
  margin: 0 auto;
}
.title-icon {
  display: inline-block;
  width: 68px;
  height: 68px;
  background-image: url("../../assets/images/download/d-sase.png");
  background-size: cover;
  margin-bottom: 24px;
}
.title-name {
  height: 42px;
  line-height: 42px;
  font-weight: 500;
  font-size: 30px;
  color: #222222;
  font-style: normal;
  text-transform: none;
  margin-bottom: 24px;
}
.title-desc {
  width: 654px;
  font-weight: 400;
  font-size: 24px;
  color: #666666;
  text-align: center;
  font-style: normal;
  text-transform: none;
  display: inline-block;
  line-height: 1.5;
  margin-bottom: 48px;
}
.content-download-a {
  display: inline-block;
}
.title-desc-en {
  width: 1200px;
  font-weight: 400;
  font-size: 24px;
  color: #666666;
  text-align: center;
  font-style: normal;
  text-transform: none;
  display: inline-block;
  line-height: 1.5;
  margin-bottom: 48px;
}
.title-btn {
  margin-bottom: 45px;
}
.btn-container {
  display: inline-block;
  width: 164px;
  height: 50px;
  line-height: 50px;
  background: #00a3d1;
  border-radius: 0px 0px 0px 0px;
  font-weight: 400;
  font-size: 20px;
  color: #ffffff;
  font-style: normal;
  text-transform: none;
  cursor: pointer;
}
.btn2 {
  background: transparent;
  border: 1px solid #00a3d1;
  font-weight: 400;
  font-size: 20px;
  color: #00a3d1;
  font-style: normal;
  text-transform: none;
}
.clinet-bg {
  display: inline-block;
  width: 776px;
  height: 370px;
  margin: 0 auto;
  background-image: url("../../assets/images/download/sase-bg.png");
  background-size: cover;
}
.clinet-bg-en {
  display: inline-block;
  width: 776px;
  height: 370px;
  margin: 0 auto;
  background-image: url("../../assets/images/download/sase-bg-en.png");
  background-size: cover;
}
.download-content {
  width: 1200px;
  padding: 60px 120px;
  margin: 0 auto;
}
.content-box {
  flex: 1;
  height: 172px;
  padding-left: 24px;
  padding-top: 24px;
  box-sizing: border-box;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.content-box:first-child {
  padding-left: 0px;
}
.content-box:last-child {
  border-right: none;
}
.content-icon {
  display: inline-block;
  width: 36px;
  height: 36px;
  margin-right: 16px;
}
.content-name {
  height: 34px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 24px;
  color: #000000;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.ios-icon {
  background-image: url("../../assets/images/download/ios.png");
  background-size: cover;
}
.android-icon {
  background-image: url("../../assets/images/download/android.png");
  background-size: cover;
}
.mac-icon {
  background-image: url("../../assets/images/download/mac.png");
  background-size: cover;
}
.window-icon {
  background-image: url("../../assets/images/download/window.png");
  background-size: cover;
}
.deb-icon {
  background-image: url("../../assets/images/download/deb.png");
  background-size: cover;
}
.harmonyOS-icon {
  background-image: url("../../assets/images/download/HarmonyOS.png");
  background-size: cover;
}
.content-info {
  height: 28px;
  font-weight: 400;
  font-size: 20px;
  color: #909090;
  text-align: left;
  font-style: normal;
  text-transform: none;
  line-height: 1.5;
}
.content-tips {
  height: 28px;
  line-height: 28px;
  font-weight: 400;
  font-size: 20px;
  color: #00a3d1;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-right: 8px;
  cursor: pointer;
}
.content-arrow {
  display: inline-block;
  width: 18px;
  height: 18px;
  background-image: url("../../assets/images/download/d-arrow.png");
  background-size: cover;
  vertical-align: top;
  margin-top: 4px;
  cursor: pointer;
}
.modal-container {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  z-index: 3000;
  background-color: rgba(0, 0, 0, 0.4);
}
.modal-box {
  position: absolute;
  width: 594px;
  height: 502px;
  top: 50%;
  left: 50%;
  margin-left: -297px;
  margin-top: -251px;
  background: #fff;
  border-radius: 16px;
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.modal-header {
  height: 206px;
  padding: 50px 65px 0;
  background-image: url("../../assets/images/download/modal-bg.png");
  background-size: cover;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  box-sizing: border-box;
}
.modal-title {
  height: 28px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 20px;
  color: #000000;
  text-align: center;
  font-style: normal;
  text-transform: none;
  margin-bottom: 24px;
}
.modal-close {
  position: absolute;
  display: inline-block;
  width: 36px;
  height: 36px;
  top: 20px;
  right: 20px;
  background-image: url("../../assets/images/download/close.png");
  background-size: cover;
  cursor: pointer;
  z-index: 50000;
}
.modal-btn {
  display: inline-block;
  width: 216px;
  height: 62px;
  background: #00a3d1;
  border-radius: 8px 8px 8px 8px;
  padding: 10px 0;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
}
.title-h1 {
  height: 25px;
  line-height: 25px;
  font-weight: 500;
  font-size: 18px;
  color: #ffffff;
  font-style: normal;
  text-transform: none;
}
.title-h3 {
  height: 17px;
  line-height: 17px;
  font-weight: 400;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  font-style: normal;
  text-transform: none;
}
.modal-content {
  padding: 0 69px;
  box-sizing: border-box;
}
.modal-tips {
  margin-top: 30px;
  margin-bottom: 16px;
  height: 22px;
  line-height: 22px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #000000;
  text-align: center;
  font-style: normal;
  text-transform: none;
}
.modal-tips-img-1 {
  display: inline-block;
  width: 216px;
  height: 154px;
  background-image: url("../../assets/images/download/tips1.png");
  background-size: cover;
}
.modal-tips-img-2 {
  display: inline-block;
  width: 216px;
  height: 154px;
  background-image: url("../../assets/images/download/tips2.png");
  background-size: cover;
}
.modal-tips-title-1 {
  display: inline-block;
  width: 216px;
  margin-top: 8px;
  height: 34px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  text-align: center;
  font-style: normal;
  text-transform: none;
  line-height: 1.5;
}
.modal-tips-title-2 {
  display: inline-block;
  width: 216px;
  margin-top: 8px;
  height: 34px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  text-align: center;
  font-style: normal;
  text-transform: none;
  line-height: 1.5;
}
.modal-hidden {
  display: none;
}
.modal-show {
  display: block;
}
.harmonyOS-tip {
  margin-bottom: 12px;
  color: #666;
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/Pages/Download/DownloadSase.vue